import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface ActiveStudentsNoAttendanceResponse {
  data: Array<NoAttendanceStudent>;
  pagination: Pagination;
}

export interface NoAttendanceStudent {
  absentCount: number;
  activeClasses: number;
  activeClassNames: Array<string>;
  missingCount: number;
  presentCount: number;
  studentId: string;
  studentName: string;
  totalClasses: number;
}

export interface Pagination {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface GetActiveStudentsNoAttendanceParams {
  sessionId: string;
  page?: number;
  limit?: number;
}

export const getActiveStudentsNoAttendanceAPI = async (
  params: GetActiveStudentsNoAttendanceParams,
) => {
  const response = await baseAPI.get<ActiveStudentsNoAttendanceResponse>(
    '/dashboard/metrics/active-students/no-attendance',
    {
      params,
    },
  );
  return response.data;
};

export const useGetActiveStudentsNoAttendance = (
  params: GetActiveStudentsNoAttendanceParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.ACTIVE_STUDENTS_NO_ATTENDANCE,
      params.sessionId,
      ...(params.page ? [params.page] : []),
      ...(params.limit ? [params.limit] : []),
    ],
    queryFn: () => getActiveStudentsNoAttendanceAPI(params),
    enabled: !!params.sessionId,
  });
};
